import React, { useState, useEffect } from "react";
import axios from "axios";
import { Checkbox, Divider, message, Select, Space } from "antd";

import { PAYMENT_GATEWAYS } from "../../constants/paymentGateways";

import { PERMISSIONS } from "../../constants/roles";
import { usePermissions } from "../App/PermissionContext";

const UserPreferences = ({ merchantId, currentPreferences, isSubAccount }) => {
  const { permissions } = usePermissions();
  const [preferences, setPreferences] = useState(currentPreferences || {});
  const [canEdit, setCanEdit] = useState(false);
  const [saving, setSaving] = useState(false);
  const disabled = !canEdit || saving;

  useEffect(() => {
    setCanEdit(!!permissions?.includes(PERMISSIONS.UPDATE_BETA_FEATURES));
  }, [permissions]);

  useEffect(() => {
    setPreferences(currentPreferences || {});
  }, [currentPreferences]);

  const onChange = async (changes) => {
    const previous = preferences;
    setPreferences((prev) => ({ ...prev, ...changes }));
    // Controls stay disabled until the save settles, so toggles can't race each other
    setSaving(true);

    try {
      const res = await axios.put(`/api/merchants/${merchantId}/preferences`, changes);
      const saved = res.data?.data?.preferences;
      if (saved) setPreferences(saved);

      message.info("Updated");
    } catch (err) {
      setPreferences(previous);
      message.error(err.response?.data?.message || err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <Divider />
      <Space direction="vertical" size="middle">
        <div>
          Top Up Payment Gateway:
          <Select
            placeholder="Default"
            allowClear
            style={{ width: 200, marginLeft: 10 }}
            disabled={disabled}
            value={preferences.paymentGateway ?? undefined}
            onChange={(paymentGateway) => onChange({ paymentGateway: paymentGateway ?? null })}
          >
            {Object.values(PAYMENT_GATEWAYS).map((gateway) => (
              <Select.Option key={gateway.key} value={gateway.key}>
                {gateway.label}
              </Select.Option>
            ))}
          </Select>
        </div>

        <div>
          Payout Payment Gateway:
          <Select
            placeholder="Default"
            allowClear
            style={{ width: 200, marginLeft: 10 }}
            disabled={disabled}
            value={preferences.payoutPaymentGateway ?? undefined}
            onChange={(payoutPaymentGateway) => onChange({ payoutPaymentGateway: payoutPaymentGateway ?? null })}
          >
            {Object.values(PAYMENT_GATEWAYS).map((gateway) => (
              <Select.Option key={gateway.key} value={gateway.key}>
                {gateway.label}
              </Select.Option>
            ))}
          </Select>
        </div>

        {!isSubAccount && (
          <Checkbox
            checked={!!preferences.allowSubAccountMarketing}
            disabled={disabled}
            onChange={(e) => onChange({ allowSubAccountMarketing: e.target.checked })}
          >
            Allow sub-accounts to receive marketing (Brevo marketing list, Abandoned Cart, Abandoned Top-up, Monthly Summary, First Delivered Order) — blocked by default
          </Checkbox>
        )}
      </Space>
    </>
  );
};

export default UserPreferences;
